import { render, staticRenderFns } from "./DeansIndex.vue?vue&type=template&id=307c9c29"
import script from "./DeansIndex.vue?vue&type=script&lang=js"
export * from "./DeansIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports